import React, { useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useLoading } from '@contexts/loading.context'
import AdminLoading from './admin-loading'

interface LoadingTransitionProps {
  children: React.ReactNode
}

const LoadingTransition: React.FC<LoadingTransitionProps> = ({ children }) => {
  const { isLoading } = useLoading()

  // Prevent scrolling when loading screen is active
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isLoading])

  return (
    <>
      <AnimatePresence>{isLoading && <AdminLoading />}</AnimatePresence>
      {children}
    </>
  )
}

export default LoadingTransition
